var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isOnline)?_c('div',{staticClass:"error-box"},[_vm._v(" "+_vm._s(_vm.$t("identification.no_internet_connection"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }